/* Cacao Rituals – Trustpilot-Werte live laden (2026-10-07)
   Quelle: Daten des kostenlosen Trustpilot-Widgets "Micro Review Count".
   Fällt die Abfrage aus, bleiben die Werte aus den Theme-Einstellungen stehen. */
(function () {
  if (window.crTpLive) return;
  window.crTpLive = true;

  var SOURCE = 'https://widget.trustpilot.com/trustbox-data/5419b6a8b0d04a076446a9ad?businessUnitId=64d9dc63bb8fcb6fa88f882e&locale=de-CH';
  var CACHE_KEY = 'crTpData';
  var MAX_AGE = 6 * 60 * 60 * 1000;
  var data = null;

  function fmt(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function apply(root) {
    if (!data) return;
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-tp]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var key = el.getAttribute('data-tp');
      if (key === 'score') el.textContent = data.score.toFixed(1);
      else if (key === 'count') el.textContent = fmt(data.total);
      else if (key === 'stars') el.style.setProperty('--cr-tp-pct', (data.score * 20) + '%');
      else if (key === 'label') el.hidden = data.score < 4.3;
      else if (/^n[1-5]$/.test(key)) el.textContent = fmt(data.counts[key.charAt(1)]);
      else if (/^w[1-5]$/.test(key)) el.style.width = (data.total ? Math.round(data.counts[key.charAt(1)] / data.total * 100) : 0) + '%';
    }
  }

  function parse(json) {
    var bu = json && (json.businessEntity || json.businessUnit);
    if (!bu || typeof bu.trustScore !== 'number' || !bu.numberOfReviews) return null;
    var r = bu.numberOfReviews;
    return {
      score: bu.trustScore,
      total: r.total,
      counts: { 5: r.fiveStars, 4: r.fourStars, 3: r.threeStars, 2: r.twoStars, 1: r.oneStar }
    };
  }

  try {
    var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
    if (cached && Date.now() - cached.t < MAX_AGE) data = cached.d;
  } catch (e) {}

  function start() {
    apply(document);
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < list[i].addedNodes.length; j++) {
            var n = list[i].addedNodes[j];
            if (n.nodeType === 1) apply(n.matches && n.matches('[data-tp]') ? n.parentNode : n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (data) return;
    fetch(SOURCE, { credentials: 'omit', referrerPolicy: 'no-referrer' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        var d = parse(json);
        if (!d) return;
        data = d;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        apply(document);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
